require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-going-back-to-the-roots-to-evolve.json") })
        }
      }, "path---blog-going-back-to-the-roots-to-evolve");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-going-back-to-the-roots-to-evolve!./.cache/json/blog-going-back-to-the-roots-to-evolve.json
// module id = 259
// module chunks = 231608221292675